import React from 'react'
import styled from 'styled-components';
import { Oval } from 'react-loader-spinner'


function DeviceEvents({
    jsonData,
    totalEvents,
    isLoading = true
}) {


    const boltColors = ['#f1c40f', '#2ecc71'];
    const statusClass = ['notreaded', 'readed'];
    const statusName = ['No leido', 'Leido'];
    const commandName = {
        'manage_power': 'Gestionar energía',
        'restart' : 'Reinicio de dispositivo'
    };
    const valueName = {
        'restore' : 'Reconectar',
        'cut' : 'Cortar',
        'restart' : 'Reiniciar'
    }; 

    const tdbgcolor = ['#fff', '#f6f6f6'];

    const createFileds = (json) => {
        return json.map(({ received_at, status, command, value }, index) => {
            return (
                <tr style={{background : tdbgcolor[index % 2]}}>
                    <DeviceCell ><span className={`status ${statusClass[status]}`}>{statusName[status]}</span></DeviceCell>
                    <DeviceCell>{received_at || 'No seteado'}</DeviceCell>
                    <DeviceCell>{commandName[command] || 'No seteado'}</DeviceCell>
                    <DeviceCell>{valueName[value] || 'No seteado'}</DeviceCell>
                </tr>
            );
        });
    }

    return (
        <Container>
            {isLoading ? 
            <Oval
                visible={true}
                height="40"
                width="40"
                color="#4fa94d"
                ariaLabel="Cargando eventos"
                wrapperStyle={{}}
                wrapperClass=""
            />
            :<List>
                <table id="device_table">
                    <thead>
                        <tr>
                            <th>Estado</th>
                            <th>Fecha y hora</th>
                            <th>Comando</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {createFileds(jsonData)}
                    </tbody>
                </table>
            </List>}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
    min-height: 300px;
    height: auto;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    font-family: 'Segoe UI', sans-serif;
    background: #f8f9fb;
`

const List = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 95%;
    height: 95%;
    border-radius: 8px;
    overflow: hidden;
    font-family: 'Segoe UI', sans-serif;
    


    table {
        width: 95%;
        border-collapse: collapse;
    }

    thead tr{
        background: #f6f6f6;
    }

    th{
        height: 54px;
        text-align: left;
        font-size: 14px;
    }

    input[type="text"] {
        display: flex;
        width: 8.4375rem;
        height: 2rem;
        align-items: center;
        padding: 0 0.625rem;
        text-align: center;

        border-radius: 0.5rem;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background-color: #F8F8F8;
    }
`

const DeviceCell = styled.td`
    height: 54px;
    text-align: left;
    font-size: 14px;

    svg{
        font-size: 24px;
        vertical-align: middle;
        color: ${(props) => props.$currentColor};
    }

    .status{
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 12px;
        border-radius: 20px;
        padding: 4px 10px;
        width: 35%;

        &.readed {
            background-color: #d4f5d3;
            color: #2ecc71;
        }

        &.notreaded {
            background-color: #fff4d3;
            color: #f1c40f;
        }

        &.inactive {
            background-color: #FF3B304D;
            color: #ff3a30d7;
        }
    }
`

export default DeviceEvents
